export const getAssetEncoding = (): string => {
	const assetEncodings = Array.prototype.map
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i) =>
			i.getAttribute('data-encoding'),
		) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		.reduce<Record<string, any>>((acc, i) => {
			// @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
			acc[i] = true;
			return acc;
		}, {});

	const uniqueEncodings = Object.keys(assetEncodings).sort();
	let result = 'unknown';

	if (uniqueEncodings.length === 1) {
		[result] = uniqueEncodings;
	}

	if (uniqueEncodings.length > 1) {
		result = `mixed: ${uniqueEncodings.toString()}`;
	}

	return result;
};
